import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const LichtenSmokenPage = () => {
  return <main data-id="element-935" data-mp="ggoy80eiy7z0">
      <SEO title="Lichten Smoken Almere | Koplampen & Achterlichten | BKCustoms" description="Professioneel lichten smoken in Almere vanaf €130. Geef uw auto een sportieve look met getinte koplampen en achterlichten. Behoud van lichtsterkte gegarandeerd." canonical="/diensten/lichten-smoken" data-id="element-936" data-mp="gii43dhbco5y" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-937" data-mp="zgb8kk7l565g">
        <div className="absolute inset-0 overflow-hidden" data-id="element-938" data-mp="zf04eja89wdt">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-939" data-mp="vezdhz5xzspv"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Sz73Ji6DM6jfsjFgLE8Pn/G22-CSL-Red-768x511.webp" alt="Lichten smoken in Almere" className="w-full h-full object-cover object-center" data-id="element-940" data-mp="vcmz1vze80hk" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-941" data-mp="tx7z0wrequ7j">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-942" data-mp="yvj6x1y56un4">
            <span className="text-[#D6281F]" data-id="element-943" data-mp="k6ddxvpwe0no">Lichten Smoken Almere</span> - Voor
            een sportieve look
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-944" data-mp="p4oj3t58zmzk">
            Geef uw auto in Almere een unieke, krachtige look met professioneel
            getinte lichten terwijl de originele lichtsterkte behouden blijft.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-945" data-mp="g637khy7188a">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-946" data-mp="18sux59tdwaz">
              <span className="mr-2" data-id="element-947" data-mp="20kd8ss9vz042">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-948" data-mp="20jty9wmkfe02" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-949" data-mp="1z3px0tv7oi2t">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-950" data-mp="2hu7e216olp8c">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-951" data-mp="2hw1xtc67vbau">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-952" data-mp="2cvw4zso7nir6">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-953" data-mp="282l7ii5agebx">
              <div className="relative" data-id="element-954" data-mp="242st3ot7rdyn">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-955" data-mp="241rj7nnxoxii"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-956" data-mp="2vtqkmpjugsij">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Sz73Ji6DM6jfsjFgLE8Pn/G22-CSL-Red-768x511.webp" alt="Professioneel lichten smoken in Almere" className="w-full h-auto object-cover" data-id="element-957" data-mp="ib2q3irn9ccb" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-958" data-mp="w8hh2rxjps6e">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-959" data-mp="118vqadavv860">
                Lichten Smoken Almere - Vanaf €130
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-960" data-mp="166xbb3rvdhk4">
                Lichten smoken is een populaire styling techniek waarbij de
                koplampen en achterlichten van uw auto worden voorzien van een
                lichte tot medium tint, wat resulteert in een sportievere en
                meer onderscheidende uitstraling.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-961" data-mp="1p0146mx9jqdo">
                Bij BKCustoms in Almere gebruiken we hoogwaardige folie die
                speciaal is ontworpen voor autolichten, waardoor de
                lichtopbrengst minimaal wordt beïnvloed terwijl het uiterlijk
                aanzienlijk verbetert.
              </p>
              <div className="space-y-4 mb-8" data-id="element-962" data-mp="1g3sn5suohcul">
                <div className="flex items-center" data-id="element-963" data-mp="1g40xbczf2423">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-964" data-mp="sdol3px51l5p">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-965" data-mp="sfrgkph286ht" />
                  </div>
                  <span className="text-white/90" data-id="element-966" data-mp="ngxzyo6h7zdf">
                    Professionele installatie in Almere
                  </span>
                </div>
                <div className="flex items-center" data-id="element-967" data-mp="xbzr1pkbbbin">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-968" data-mp="xfdtsyww1mqm">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-969" data-mp="2dpg6pd61c0op" />
                  </div>
                  <span className="text-white/90" data-id="element-970" data-mp="28rocudlty4hv">Hoogwaardige materialen</span>
                </div>
                <div className="flex items-center" data-id="element-971" data-mp="2ga4hfbextnrf">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-972" data-mp="2lbbmh2pp48ue">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-973" data-mp="2l8fr9m58fy9n" />
                  </div>
                  <span className="text-white/90" data-id="element-974" data-mp="27ddkkwska4vs">
                    Behoud van optimale lichtsterkte
                  </span>
                </div>
                <div className="flex items-center" data-id="element-975" data-mp="2z38c903w66nm">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-976" data-mp="2z4jh7392pkgb">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-977" data-mp="340i74va1vaiu" />
                  </div>
                  <span className="text-white/90" data-id="element-978" data-mp="2q9ddqax9zegy">
                    Verschillende tint-opties beschikbaar
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-979" data-mp="3i0025sdxvk0n">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-980" data-mp="3mrrlpiyogpha">
                  <span className="mr-2" data-id="element-981" data-mp="3sk23zcou9i1x">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-982" data-mp="3nm0muxaz3st3" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-983" data-mp="3io8tdyuojyms">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What We Offer Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-984" data-mp="2zz24tv77gct2">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-985" data-mp="2uy4qxut8a4xd">
          <div className="text-center mb-16" data-id="element-986" data-mp="2uxmjs35126ao">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-987" data-mp="2pyt8mhd7qrdo">
              Lichten Smoken in <span className="text-[#D6281F]" data-id="element-988" data-mp="2fvw9ffpaxnc6">Almere</span>
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-989" data-mp="2fxqt6qou79eo">
              Bij BKCustoms in Almere kunnen we diverse lichten van uw auto
              professioneel smoken
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-990" data-mp="2usneo5lnpt9p">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-991" data-mp="2urvoxbeqqprc">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-992" data-mp="1x67rcn6ju1e8">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-993" data-mp="22519wu0p0il9" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-994" data-mp="272jbu0galxjr">
                Achterlichten
              </h3>
              <p className="text-white/80" data-id="element-995" data-mp="2buuirn9gajlt">
                Geef uw achterlichten een sportieve, getinte look die uw auto
                een agressievere uitstraling geeft zonder de zichtbaarheid te
                compromitteren.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-996" data-mp="2xjotnfyog9fg">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-997" data-mp="2xlru6txghkyf">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-998" data-mp="2tk6d0wdw2kif" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-999" data-mp="37jpfp9nxl3nc">Koplampen</h3>
              <p className="text-white/80" data-id="element-1000" data-mp="32i02poh5efwm">
                Subtiel getinte koplampen voor een unieke look die uw auto
                onderscheidt van de massa, met behoud van optimale lichtsterkte.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1001" data-mp="3cf4t60i10xj8">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1002" data-mp="3q8473y25ujoo">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1003" data-mp="3lakiq5br0qj0" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1004" data-mp="40mgtml1yvtt">Mistlampen</h3>
              <p className="text-white/80" data-id="element-1005" data-mp="3v7yx7ze4358o">
                Completeer de look met getinte mistlampen die perfect aansluiten
                bij de stijl van uw getinte kop- en achterlichten.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-1006" data-mp="moev07lm8yzu">
            <p className="text-white/70 text-lg" data-id="element-1007" data-mp="8px7oazmhoig">
              Lichten smoken in Almere vanaf €130, afhankelijk van het type auto
              en de hoeveelheid lichten.
              <br data-id="element-1008" data-mp="dn6xvsuu647c" />
              Neem contact met ons op voor een persoonlijke offerte.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-1009" data-mp="3rne24tjqvyy">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-1010" data-mp="3m5d1t0dp2i8u">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1011" data-mp="3m30cu39ir7ma">
            Klaar voor een sportievere look met lichten smoken in Almere?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-1012" data-mp="3c7owjgigpscf">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1013" data-mp="2b6lm75kiy860">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1014" data-mp="2g71141kgfnq3">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-1015" data-mp="26a4zmfsz41v1">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};